import { ArrowUpRight, CheckCircle } from 'lucide-react';
import React from 'react'
import { Link } from 'react-router-dom';

function BudgetingCashFlow() {
    const faqData = [
        {
          title: "Financial & Tax Planning",
          items: [
            "Plan how to best organize finances to minimize taxes",
            "Include planning for retirement, business succession, sale, or business setup",
            "Preliminary tax planning advice for minimizing taxes and business succession"
          ],
        },
        {
          title: "Business Planning & Cash Flow Management",
          items: [
            "Prepare Business Plans according to your vision and objectives",
            "Prepare a Cash Flow Budget to keep the business functional each month",
            "Prepare projected financial statements to secure bank loans",
            "Projects how much operating line of credit would be required",
            "Projects when loans can be repaid"
          ],
        },
        {
          title: "Budgeting & Financial Analysis",
          items: [
            "Provides a budget against which you can compare actual cash flows",
            "Helps communicate business plans and credit needs to lenders",
            "Examining results to look for trends and provide feedback to the company",
            "Looking at areas of concern and offering solutions to improve financial processes"
          ],
        }
      ];

        
    return (
        <div>
           {/* Hero Section */}
           <section
            className="relative text-center w-full h-[600px]"
            style={{
              backgroundImage: "url('images/bg3.jpeg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
              <h1 className="text-4xl font-bold mb-4 md:text-8xl">Budgeting & Cash Flow </h1>
              <p className="text-lg max-w-3xl text-gray-400 md:text-3xl">
              Optimize your finances with strategic planning and cash flow management. Ensure stability, growth, and a strong financial future!
              </p>
            </div>
          </section>
    
    
          <div className="flex flex-col items-center text-center gap-12 bg-slate-900 py-12 px-6 md:px-16">
      <h2 className="text-4xl md:text-6xl font-bold text-gray-100">
      Budgeting & Cash Flow Management
      </h2>
    
      <p className="text-2xl max-w-5xl text-justify text-gray-400  mx-auto">
      Take control of your finances with expert budgeting and cash flow management.  
  We help businesses plan, allocate resources efficiently, and maintain steady  
  cash flow to ensure financial stability. Our strategic approach minimizes risks,  
  enhances profitability, and keeps your business prepared for future growth.  
  Let us guide you in making informed financial decisions for lasting success. 
      </p>
    
      <p className="text-2xl max-w-5xl text-justify text-gray-400 mx-auto">
  Effective budgeting and cash flow management are key to business success.  
  We provide tailored strategies to track expenses, forecast revenue,  
  and optimize cash flow, ensuring your business remains financially healthy.  
  Whether you're scaling up or navigating financial challenges, our expert  
  guidance helps you stay in control, make informed decisions, and achieve  
  sustainable growth.  
</p>
      <div className="flex mt-3 justify-center">
         <Link to="/contactus">
        <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
          Schedule A Call
          <ArrowUpRight size={20} />
        </button></Link>
      </div>
    </div>
    
    <div className="max-w-3xl mx-auto p-6">
          {faqData.map((faq, index) => (
            <div key={index} className="border-b border-gray-300 pb-4 mb-4">
              <h2 className=" text-3xl md:text-4xl font-semibold text-gray-900">{faq.title}</h2>

              <ul className="mt-2 space-y-2">
                {faq.items.map((item, i) => (
                  <li key={i} className="flex text-xl mt-6 items-center text-gray-700">
                    <CheckCircle className="w-5 h-5 text-gray-500 mr-2" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        </div>
      )
    }

export default BudgetingCashFlow